const APIConfig = {baseURL: "/api"};

export default APIConfig;